import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import App from "./App.js";
import "./index.css";
import { store } from "./redux/store.js";
import { GlobalStyles } from "./styles/global";
import { theme, darkTheme } from "./styles/theme";

import { Provider } from "react-redux";
import { DarkModeProvider } from "./DarkModeProvider.jsx";
import { NextUIProvider } from "@nextui-org/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <DarkModeProvider>
          <GlobalStyles />
          <NextUIProvider>
            <App />
          </NextUIProvider>
        </DarkModeProvider>
      </ThemeProvider>
    </Provider>
  </Router>
);
